import { useTheme } from 'next-themes';

interface TokenIconProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
}

/**
 * Token icon component that automatically switches between light and dark versions
 * based on the current theme.
 */
export const TokenIcon = ({ src, alt, width = 20, height = 20, className }: TokenIconProps) => {
  const { resolvedTheme } = useTheme();

  // Replace /icons/light/ with /icons/dark/ when in dark mode
  const iconSrc = resolvedTheme === 'dark' && src.includes('/icons/light/')
    ? src.replace('/icons/light/', '/icons/dark/')
    : src;

  return (
    <img
      src={iconSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
    />
  );
};
